<template>
  <div class="alarm-status">
    <ol
      v-if="computedHasID"
      class="g-alarm-handler__row alarm-status__status-grid alarm-status__status-grid--auto-left"
    >
      <li>
        <strong>{{ $t('messages.sharedTexts.status.status') }}:</strong>
        <strong
          v-if="alarmActive"
          class="g-text g-text--green"
        >
          {{ $t('messages.sharedTexts.status.active') }}
        </strong>
        <span
          v-else
        >
          {{ $t('messages.sharedTexts.status.inactive') }}
        </span>
      </li>
      <li v-if="alarm.activeDT">
        <strong>{{ $t('messages.sharedTexts.controls.start') }}:</strong><span>{{ alarm.activeDT }}</span>
      </li>
      <li v-if="!alarmActive">
        <strong>{{ $t('messages.sharedTexts.controls.end') }}:</strong><span>{{ alarm.passiveDT }}</span>
      </li>
      <slot />
    </ol>
    <div v-else>
      <strong
        class="g-text g-text--yellow"
      >
        Cannot show Status in test mode
      </strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AlarmStatus',
  props: {
    alarm: {
      type: Object,
      default: function() {
        return {
          id: 1,
          label: 'label',
          urgency: 2,
          active: '1574130120000',
          passive: '',
          activeDT: 'Nov 19th 2019, 2:22 AM',
          passiveDT: null,
          state: 'yellow',
          handler: 'service-station-alarm',
          seen: false,
          fixed: false
        }
      }
    },
    alarmActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    computedHasID() {
      return this.alarm && this.alarm.id !== undefined
    }
  }
}
</script>

<style lang="scss">
.alarm-status {
  &__status-grid {
    > li {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      padding: 10px 0;
      &:nth-child(even) {
        background: lighten($color-grey, 20);
      }
    }
  }
}
</style>
